import { render, staticRenderFns } from "./JournalLpo__pagination.vue?vue&type=template&id=270f6222&scoped=true&"
import script from "./JournalLpo__pagination.vue?vue&type=script&lang=js&"
export * from "./JournalLpo__pagination.vue?vue&type=script&lang=js&"
import style0 from "./JournalLpo__pagination.vue?vue&type=style&index=0&id=270f6222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f6222",
  null
  
)

export default component.exports